// extracted by mini-css-extract-plugin
export default {"root":"style_root__2sihp","content":"style_content__U+5aU","spreadsheet":"style_spreadsheet__ooUva","reload":"style_reload__wadZ0"};